import type { Ticket } from "../../../../models/Ticket";

/** Asortyment „Rezerwacja” z ESOK — dopasowanie nazwy bez rozróżniania wielkości liter (cały string). */
export function isReservationAssortName(name: string | undefined | null): boolean {
  return (name ?? "").trim().toLowerCase() === "rezerwacja";
}

export function filterReservationAssortTickets(
  tickets: Ticket[],
  showReservationsOnMyAccountPanel: boolean | undefined,
): Ticket[] {
  if (showReservationsOnMyAccountPanel !== false) {
    return tickets;
  }
  return tickets.filter((t) => !isReservationAssortName(t.name));
}
